import { render } from "./FrontHeader.vue?vue&type=template&id=afba2a2a&scoped=true"
import script from "./FrontHeader.vue?vue&type=script&lang=js"
export * from "./FrontHeader.vue?vue&type=script&lang=js"

import "./FrontHeader.vue?vue&type=style&index=0&id=afba2a2a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afba2a2a"]])

export default __exports__